import { createPinia } from "pinia";
import { createApp } from "vue";

import "@/assets/styles/main.css";
import "virtual:vite-svg-2-webfont.css";

import App from "@/App.vue";
import { router } from "@/router";

const pinia = createPinia();
const appContainer = document.getElementById("app");
if (appContainer !== null) {
  const app = createApp(App);

  app.use(pinia);
  app.use(router);
  app.mount(appContainer);
}
